export const salaryTypeConstants = [
    { name: "Gross", value: "gross" },
    { name: "Basic", value: "basic" },
];